import {EntityState} from '@ngrx/entity';
import {Discover} from '../../../domain/Discover';
import {adapterDiscovers} from '../adapters/discovers.adapters';


export interface IDiscoversState extends EntityState<Discover> {}

export const initialDiscoversState : IDiscoversState = adapterDiscovers.getInitialState({});
